export const GalleryImg = [
 
  
  {
    testimony: 'LOKL ha impactado mi vida, pude invertir por primera vez en propiedad raíz, fácil, sencilla, con poco capital y de manera segura.',
    img: 'https://lokl-assets.s3.amazonaws.com/home/gallery-img-4.png',
  },
  
  {
    testimony: 'LOKL ayuda a que las personas que tienen poca capacidad de inversión, puedan tener una oportunidad de invertir en grandes proyectos.',
    img: 'https://lokl-assets.s3.us-east-1.amazonaws.com/lokl/img-person-3.jpg',
  },
  {
    img: 'https://lokl-assets.s3.amazonaws.com/home/testimony-thumbnail-1.jpg',
    video: 'https://lokl-assets.s3.amazonaws.com/home/testimony-1.mp4'
  },
  {
    testimony: 'Proyecto innovador, a bajos montos, con una gran valorización. ',
    img: 'https://lokl-assets.s3.amazonaws.com/home/gallery-img-7.png',
  },
 
]